import type {createPolicyControlPlane, PolicyPermission} from '../../../packages/admin/policy-publish.ts';

type PolicyControlPlane = ReturnType<typeof createPolicyControlPlane>;

export interface AdminComboRuntimeHost {
  readonly controlPlane: PolicyControlPlane;
  readonly actorId: string;
  readonly permissions: readonly PolicyPermission[];
}

type AdminGlobal = typeof globalThis & {__MOREFUNOS_ADMIN_COMBO__?: AdminComboRuntimeHost};

export function resolveAdminComboRuntimeHost(): AdminComboRuntimeHost | null {
  const candidate = (globalThis as AdminGlobal).__MOREFUNOS_ADMIN_COMBO__;
  if (!candidate?.controlPlane || !candidate.actorId?.trim() || !Array.isArray(candidate.permissions)) return null;
  return candidate;
}
